import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DefaultDraftItem } from '../../models/default-draft-template.model';

@Injectable({
  providedIn: 'root'
})
export class PlanningDefaultDraftsHttpService {
  private readonly base_url = '/planning/templates/default/draft';

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAll(params?: any): Observable<{ cursor: string, list: DefaultDraftItem[] }> {
    return this.http
      .get<{ cursor: string, list: DefaultDraftItem[] }>(this.base_url, {params});
  }

  getOne(id: string): Observable<DefaultDraftItem> {
    return this.http.get<DefaultDraftItem>(`${this.base_url}/${id}`);
  }

  update(id: string, payload: any): Observable<DefaultDraftItem> {
    return this.http.post<DefaultDraftItem>(`${this.base_url}/${id}`, payload);
  }
  rename(id: string, payload: any): Observable<DefaultDraftItem> {
    return this.http.post<DefaultDraftItem>(`${this.base_url}/${id}/rename`, payload);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base_url}/${id}`);
  }
}
